import { useContext, useRef, useEffect, useMemo, useState } from 'react';
import { AppContext } from 'Context';
import { ALLOWED_UPLOADS_COUNT, PLANS } from 'Commons';
import useSWR from 'swr';
import Paper from '@mui/material/Paper';
import { axios, dataFetcher, endpoints, baseUrl } from 'Api';
import Table from '@mui/material/Table';
import { ref, get, getDatabase, off, onValue, update } from 'firebase/database';
import { toast } from 'react-toastify';
import Spinner from 'Components/Spinner';
import ListItemText from '@mui/material/ListItemText';
import { v4 as uuid } from 'uuid';
import AWS from 'aws-sdk';
import { addS3VideoDraftContent, addVideoDraftContent, addPhotoContent } from 'Api/apiFunctions';
import { saveUploadInfo, saveUploadDetails, saveTitle, saveDummy, removeDummy, removeTitle } from 'store/store';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import { useSelector, useDispatch } from 'react-redux';
import noImageAvailable from 'Assets/noimage-available.png';
import ForNoImage from 'Assets/Placeholder.png';
import generatingThumbnail from 'Assets/generating-thumbnail.jpg';
import noPhotoAvailable from 'Assets/no-image-available.png';
import CloudUpl from 'Assets/cloud-upload.png';
import OutlinedInput from '@mui/material/OutlinedInput';
import TableHead from '@mui/material/TableHead';
import InputLabel from '@mui/material/InputLabel';
import { ReactComponent as CloseIcon } from 'Assets/close.svg';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import TableRow from '@mui/material/TableRow';
import { Checkbox as MuiCheckbox, withStyles, Typography } from '@material-ui/core';
import { Check as CheckIcon } from '@material-ui/icons'; // Import the CheckIcon
import { Tooltip, Dialog, DialogTitle, DialogContent, DialogActions, Button, FormControl as MuiFormControl, Select as MuiSelect, MenuItem as MuiMenuItem, InputLabel as MuiInputLabel, Tabs, Tab, TextField } from '@mui/material';
import TitleIcon from '@mui/icons-material/Title';
import DescriptionIcon from '@mui/icons-material/Description';
import CategoryIcon from '@mui/icons-material/Category';
import VisibilityIcon from '@mui/icons-material/Visibility';
import RefreshIcon from '@mui/icons-material/Refresh';
import getMyContentsBasedOnUploadDate from '../Api/getMyContentsBasedOnUploadDate';
import { Radio } from './upload-modal/components/Material-reDesign';
import { Checkbox, StyledCheckbox } from '../Pages/private/videos/components/CustomDesigns';
import { GroupSelector } from './group-selector/index';
import { awsConfig, generateS3Url, getBucketName, getBucketNamePath } from '../Api/awsConfig';
import styles from './Listing.module.css';
import { Pathname } from '../Routes';
import DeleteIcon from '../Assets/delete.png';
import SpinnerImage from '../Assets/Spinner-3.gif';

export default function ListingModal({ Welcome, buttonText, setButtonText, open, key, videoFiles, setVideoFiles, setOpen, setEditLoader }) {
  // const navigate = useNavigate();
  const { setAppSnackbar, s3Data, firebaseDatabase, setVideoUploadedParts, langText, userDetails,
    setUploadContainer, setIamUploading, setdisableDrag, setdidIOpenModal, subscriptionDetails,
    autoSignIn, setSelectedFiles, uploadQueue, setUploadQueue, activeUploads, setActiveUploads, navigateToInviteFirstTime, draftOfUpload, setDraftOfUpload, MAX_VIDEOS, uploadProcessing,
    setUploadProcessing, setNavigateOnceClicked, setUploadContainer2, setAllvideoData, defaultCategoryName, photoList,
    setPhotoList, setCategoryRefreshTrigger, setTabTitle, MAX_SIZE_GB, selectedItemsInBulk, setSelectedItemsInBulk,
    processUploadQueue, findAllVideoCategory, setFindAllVideoCategory, videoThumbnails, setVideoThumbnails, videoThumbnails64,
    setVideoThumbnails64, activeTab, setActiveTab } = useContext(AppContext);
  const spinerSmall = 'spinex';
  const uploadPercentages = useSelector((state) => state.upload);
  const handleClose = (event) => {
    event.stopPropagation();
    setOpen(false);
  };
  console.log('findAllVideoCategory', findAllVideoCategory);
  const defaultVideoDetails = {
    name: undefined,
    duration: undefined,
    size: undefined,
  };
  const test = useSelector((state) => state.titleBulk);
const dispatch = useDispatch();
const updateTitle = (draft_id, data, status = 1) => {
  if (status === 1) {
    dispatch(saveTitle({ [draft_id]: data }));
  } else {
    dispatch(removeTitle(draft_id));
  }
};
  const getToken = () => localStorage.getItem('token');
  const videoRef = useRef(null);
  const databaseRef = ref(firebaseDatabase, 'status_from_sns');
  const userId = userDetails?.isSubscription?.user_id;
  const [t, setT] = useState(false);
  const [videoDetails, setVideoDetails] = useState(defaultVideoDetails);
  const [videoGroup, setVideoGroup] = useState([]);
  const [videoVisibility, setVideoVisibility] = useState(null);
  const [options, setOptions] = useState([]);
  // const [isVisible, setIsVisible] = useState(true);
  const [thumbnailGenerationStatus, setThumbnailGenerationStatus] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [isItDelete, setisItDelete] = useState(true);
  const [title, setTitle] = useState('');
  const [addEditCategory, setAddEditCategory] = useState(false);
  const [addingNewCategory, setAddingNewCategory] = useState({});
  const [categrory, setCategrory] = useState(undefined);
  const [arrayUpdater, setarrayUpdater] = useState(false);
  const [isSyncEnabled, setIsSyncEnabled] = useState(false); // Switch state to control sync
  const [lastSelectedCategory, setLastSelectedCategory] = useState({ value: '', name: '' });
  // const [buttonText, setButtonText] = useState('Save to Draft');

  const [droper, setDroper] = useState(false);
  const handleCancel = (e, i) => {
    setTitle('');
    // setAddingNewCategory((prevState) => ({
    //   ...prevState,
    //   [i]: false, // Set the specific index to false
    // }));
  };
  const [updateTrigger, setUpdateTrigger] = useState(false);
  function formatFileSizeAccMb(sizeInBytes) {
    const megabyte = 1024 * 1024;
    const sizeInMB = sizeInBytes / megabyte;
    return sizeInMB.toFixed(2);
  }

  useEffect(() => {
    // eslint-disable-next-line
    videoFiles.forEach((file) => {
      // eslint-disable-next-line
      file.draftId = uuid();
    });
  }, [updateTrigger]);
  useEffect(() => {
    const statuses = Object.values(thumbnailGenerationStatus);
    const anyGenerating = statuses.some((status) => status === 'generating');
    if (anyGenerating && isItDelete) {
      setIsLoading(true);
    } else {
      const allSuccessOrFailed = statuses.every((status) => status === 'success' || status === 'failed');
      if (allSuccessOrFailed) {
        setIsLoading(false);
      }
    }
  }, [thumbnailGenerationStatus]);
  useEffect(() => {
    const allItems = videoFiles.map((obj, i) => ({
      token: getToken(),
      group_ids: selectedItemsInBulk[i]?.group_ids,
      draftId: obj?.draftId,
      thumbnails: videoThumbnails[obj?.draftId],
      name: obj.name,
      description: selectedItemsInBulk[i]?.description,
category: (selectedItemsInBulk[i]?.category === '' || selectedItemsInBulk[i]?.category === undefined)
    ? findAllVideoCategory?.value
    : selectedItemsInBulk[i]?.category,
categoryName:
  (selectedItemsInBulk[i]?.categoryName === '' || selectedItemsInBulk[i]?.categoryName === undefined)
    ? findAllVideoCategory?.name
    : selectedItemsInBulk[i]?.categoryName,

      playlist: selectedItemsInBulk[i]?.playlist,
      visibility: selectedItemsInBulk[i]?.visibility ?? '2',
      size: formatFileSizeAccMb(obj.size)
    }));
    setSelectedItemsInBulk(allItems);
  }, [videoFiles, findAllVideoCategory]);
const convertToBase64 = async (file) => {
  const reader = new FileReader();
  return new Promise((resolve, reject) => {
    reader.onloadend = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
    reader.readAsDataURL(file);
  });
};

function base64ToFile(base64String, fileName) {
  const byteString = atob(base64String);
  const arrayBuffer = new ArrayBuffer(byteString.length);
  const uint8Array = new Uint8Array(arrayBuffer);
  for (let i = 0; i < byteString.length; i += 1) {
    uint8Array[i] = byteString.charCodeAt(i);
  }
  const blob = new Blob([arrayBuffer], { type: 'image/jpeg' });
  const file = new File([blob], fileName, { type: 'image/jpeg' });
  return file;
}
  const selectGroup = (id, index) => {
    setSelectedItemsInBulk((prevItems) => {
      const updatedItems = [...prevItems];
      updatedItems[index].group_ids = videoGroup[index]?.includes(id)
        ? videoGroup[index].filter((groupId) => groupId !== id)
        : [...(videoGroup[index] || []), id];
      return updatedItems;
    });
    // Update videoGroup to keep track of groups for each item individually
    setVideoGroup((prevVideoGroup) => {
      const updatedVideoGroup = [...prevVideoGroup];
      updatedVideoGroup[index] = updatedVideoGroup[index]?.includes(id)
        ? updatedVideoGroup[index].filter((groupId) => groupId !== id)
        : [...(updatedVideoGroup[index] || []), id];
      return updatedVideoGroup;
    });
  };
  const iteratorNum = [];
  const totalNum = [];
  let tempPercentages;
  const formDataJsonString = [];
  AWS.config.update({
    region: awsConfig.region,
    accessKeyId: awsConfig.accessKey,
    secretAccessKey: awsConfig.secretKey,
  });
  AWS.config.httpOptions.timeout = 0;
  const s3 = new AWS.S3();
  const { isValidating: gettingPlaylists, mutate: getPlaylists } = useSWR(endpoints.getMyPlaylist, {
    onSuccess: ({ success, data }) => {
      if (success) {
        setOptions(data?.map(({ id, title }) => ({ name: title, value: id })));
      } else {
        setAppSnackbar({ isVisible: true, type: 'error', message: 'Oops! Something went wrong while fetching you playlists' });
      }
    },
    onError: () => {
      setAppSnackbar({ isVisible: true, type: 'error', message: 'Oops! Something went wrong while fetching you playlists' });
    },
  });

  const fetchCategories = async () => {
    try {
      const token = getToken(); // Get the token
      const response = await axios.post(
        `${baseUrl}${endpoints.getMyCategories}`,
        {}, // Empty body for the POST request
        {
          headers: {
            Authorization: `Bearer ${token}`, // Token in Authorization header
          },
        }
      );
      // Check if the response is successful
      if (response?.data?.success) {
        const responseData = response?.data?.data?.map(({ title: name, id: value }) => ({ name, value }));
        setCategrory(responseData);
        const allVideosCategory = responseData.find((cat) => cat.name === defaultCategoryName);

if (allVideosCategory) {
  setFindAllVideoCategory({
    name: allVideosCategory?.name,
    value: allVideosCategory?.value,
  });
}
        if (allVideosCategory && lastSelectedCategory?.value === '') {
setLastSelectedCategory({
    name: allVideosCategory?.name,
    value: allVideosCategory?.value,
  });
}
        // eslint-disable-next-line
      } else {
        console.error('Failed to fetch categories:', response.data.message);
        return [];
      }
    } catch (error) {
      console.error('Error fetching categories:', error);
      return [];
    }
  };
  console.log('lastSelectedCategory', lastSelectedCategory);
  useEffect(() => {
    setEditLoader(false);
    getPlaylists();
    fetchCategories();
    setdisableDrag(false);
    setButtonText('Publish');
    setIsLoading(false);
    setisItDelete(true);
    setThumbnailGenerationStatus({});
    // setdidIOpenModal(true);
    return () => {
      // setdisableDrag(true);
      setdidIOpenModal(false);
    };
  }, []);

  const updateUploadDetails = (draft_id, data) => {
    dispatch(saveUploadDetails({ [draft_id]: data }));
  };

const updateItem = (percentage, draft_id, filename, uploadPercentages, updateUploadPercentagesModal) => {
 const rawPercent = (percentage / totalNum[draft_id]) * 100;
  const percent = Math.min(100, Math.round(rawPercent)); // ✅ clamp it here
  const trimmedFilename = filename.length > 26 ? `${filename.substring(0, 26)}...` : filename;
    const newPercentages = { ...uploadPercentages, [draft_id]: percent };
    tempPercentages = newPercentages;
    updateUploadPercentagesModal(draft_id, percent);
    toast.update(draft_id, { render: `${trimmedFilename} ${percent}%`, autoClose: false });
};
const closeToast = (draft_id, message, type) => {
  toast.update(draft_id, { closeButton: false, render: message, type: type === 'success' ? toast.TYPE.SUCCESS : toast.TYPE.ERROR, autoClose: 3000 });
  setUploadContainer((prevUploadContainer) => prevUploadContainer.filter((id) => id !== draft_id));
};
async function uploadPart(bucket, key, partNumber, partBody, uploadId, setVideoUploadedParts, filename, draft_id, uploadPercentages, updateUploadPercentagesModal, partSize, startTime, fileSize) {
  const params = {
    Bucket: bucket,
    Key: key,
    PartNumber: partNumber,
    UploadId: uploadId,
    Body: partBody,
  };
  return s3.uploadPart(params)
    .promise()
    .then((data) => {
      const currentTime = new Date().getTime();
      const elapsedSize = (partNumber * partSize) / 1024 / 1024;
      const elapsedTime = (currentTime - startTime) / 1000;
      const remainingSize = (fileSize / 1024 / 1024) - elapsedSize;
      updateUploadDetails(draft_id, { elapsed_size: elapsedSize, elapsed_time: elapsedTime, remaining_size: remainingSize > 0 ? remainingSize : 0 });
      iteratorNum[draft_id] += 1;
      updateItem(iteratorNum[draft_id], draft_id, filename, uploadPercentages, updateUploadPercentagesModal);
      setVideoUploadedParts((prevState = []) => [...prevState, partNumber]);
      return data;
    })
    .catch((error) => {
      console.error(`AWS Multipart Upload : Error uploading part ${partNumber}:`, error);
      throw error; // Rethrow the error to be handled by the caller
    });
}

const queue = []; // A queue to hold the tasks
let isProcessing = false; // A flag to indicate whether the queue is being processed

async function processQueue() {
  if (isProcessing) return; // Prevent duplicate processing
  isProcessing = true;

  while (queue.length > 0) {
    const task = queue.shift(); // Take the first task
    // eslint-disable-next-line
    if (task) await task(); // Execute the task
  }

  isProcessing = false; // Reset the flag once done
}

function enqueueTask(task) {
  queue.push(task); // Add a new task to the queue
  processQueue(); // Trigger queue processing
}
const fetchContents = async () => {
  try {
      const userId = userDetails?.myId;
      const token = getToken();
      const data = await getMyContentsBasedOnUploadDate(userId, 1, '', 'date', 0);
      setAllvideoData(data?.data);
  } catch (error) {
      console.error('Failed to fetch contents:', error);
  }
};
async function sendVideoDataToServer(theGreatPayload, draft_id) {
  const apiUrl = `${baseUrl}/V6/addVideo`;
  try {
    const response = await axios.post(apiUrl, theGreatPayload);
    fetchContents();
    closeToast(draft_id, 'Uploading completed', 'success');
    autoSignIn();

    setUploadContainer2((prevUploadContainer) => prevUploadContainer?.filter((id) => id !== draft_id));
  } catch (error) {
    console.error('Error sending video data:', error);
  }
}

async function completeMultipartUpload(bucket, key, parts, uploadId, file, index) {
  const params = {
    Bucket: bucket,
    Key: key,
    MultipartUpload: {
      Parts: parts,
    },
    UploadId: uploadId,
  };
  try {
    const response = await s3.completeMultipartUpload(params).promise();
    let videoDuration = 0;
    let videoHeightI = 0;
    let videoWidthI = 0;
    try {
      const videoElement = document.createElement('video');
      videoElement.src = URL.createObjectURL(file);
      await videoElement?.load();
      videoElement.muted = true;
  // Wait for the metadata to load to access duration, height, and width
  await new Promise((resolve, reject) => {
    videoElement.addEventListener('loadedmetadata', () => {
      videoDuration = videoElement.duration;
      videoHeightI = videoElement.videoHeight;
      videoWidthI = videoElement.videoWidth;
      resolve();
    });
    videoElement.addEventListener('error', reject);
  });
  try {
    await videoElement.play();
  } catch (playError) {
    console.warn('Video play was prevented:', playError);
  }
      videoElement?.pause();
    } catch (e) {
      console.error('Error in getting width and height:', e);
    }
    const formData = new FormData();
    const s3Url = generateS3Url();
    formData.append('token', getToken());
    formData.append('draft_id', file?.draftId);

    // Handle thumbnail - convert noPhotoAvailable to blob if needed
    if (videoThumbnails[file?.draftId]?.[0]) {
      formData.append('thumbnail', videoThumbnails[file?.draftId][0]);
    } else {
      // Convert the default image to blob
      try {
        const response = await fetch(ForNoImage);
        const blob = await response.blob();
        formData.append('thumbnail', blob, 'ForNoImage.png');
      } catch (error) {
        console.error('Error converting default thumbnail to blob:', error);
        // Fallback to original approach if fetch fails
        formData.append('thumbnail', ForNoImage);
      }
    }
    if (videoThumbnails[file?.draftId] && Array.isArray(videoThumbnails[file?.draftId])) {
      videoThumbnails[file?.draftId].forEach((thumbnail) => {
        formData.append('thumbnails[]', thumbnail);
      });
    }
    formData.append('title', test[file?.draftId]);
    formData.append('video_duration', videoDuration);
    formData.append('videoOreintation', videoHeightI < videoWidthI ? 1 : 2);
    formData.append('videoHeight', videoHeightI);
    formData.append('videoWidth', videoWidthI);
    selectedItemsInBulk[index].category ? formData.append('category_id', selectedItemsInBulk[index].category) : null;
    formData.append('playlist_ids', selectedItemsInBulk[index]?.playlist?.map((item) => item?.value));
    formData.append('visibility', selectedItemsInBulk[index].visibility);
    formData.append('group_ids', selectedItemsInBulk[index]?.group_ids);
    formData.append('s3_url', `${s3Url}${getBucketNamePath(userId)}/${key}`);
    formData.append('s3_image_bucket_url', s3Url);
    formData.append('s3_status', 'Completed');
    formData.append('bucket_folder_path', `${getBucketNamePath(userId)}/${key}`);
    formData.append('video_size', formatFileSizeAccMb(file.size));
    closeToast(file?.draftId, 'Uploading completed', 'success');
    sendVideoDataToServer(formData, file?.draftId);
    if (subscriptionDetails?.current_plan === 'Free') {
      autoSignIn();
    }
    if (uploadQueue?.length <= 1) {
      if (photoList && photoList.length > 0) {
        setActiveTab(1); // Switch to photo tab
      } else {
        setOpen(false);
      }
        }
    return response;
  } catch (error) {
    console.error('Error completing multipart upload:', error);
    if (subscriptionDetails?.current_plan === 'Free') {
      autoSignIn();
    }
    throw error; // Rethrow the error to be handled by the caller
  }
}

const ChangeButton = (newCategoryStates, updatedVideoFiles, singleArray) => {
  const mergeArrays = (array1, array2) => {
    const array2Map = new Map(array2.map((item) => [item?.draftId, item]));
    const result = array1.filter((item) => !array2Map.has(item?.draftId)).concat(array2);
    return result;
};
const filteredNewCategoryStates = singleArray === 'singleArray' ? mergeArrays(newCategoryStates, selectedItemsInBulk) : newCategoryStates?.filter((categoryState) => updatedVideoFiles?.some((videoFile) => videoFile.draftId === categoryState.draftId));
  let c = 0;
  let t = 0;
  newCategoryStates.forEach((item, index) => {
    if (item?.category !== '') {
      c += 1;
    }
  });
  Object.values(videoThumbnails64).forEach((item) => {
    if (item !== undefined) {
      t += 1;
    }
  });
  const allHaveCategory = filteredNewCategoryStates?.every((item) => item.category && item.category !== '');
  const someHaveCategory = filteredNewCategoryStates?.some((item) => item.category && item.category !== '');
  if (allHaveCategory) {
    setButtonText('Publish');
  } else if (someHaveCategory) {
    setButtonText('Publish');
  } else {
    setButtonText('Publish');
  }
  };

const mediaThumGenerator = async (file, index) => {
  const video = document.createElement('video');
  video.src = URL.createObjectURL(file);
  setThumbnailGenerationStatus((prev) => ({ ...prev, [file.draftId]: 'generating' }));

  return new Promise((resolve) => {
    video.addEventListener('loadeddata', async () => {
      const interval = video.duration / 6; // Generate thumbnails at 6 different points
      const thumbnails = []; // Store generated thumbnail files

      try {
        // eslint-disable-next-line
        for (let i = 1; i <= 6; i++) {
          const seekTime = i * interval; // Calculate the seek time for each thumbnail
          video.currentTime = seekTime; // Seek to the calculated time
        // eslint-disable-next-line
          const thumbnailFile = await new Promise((innerResolve, innerReject) => {
            const onSeeked = () => {
              const canvas = document.createElement('canvas');
              canvas.width = video.videoWidth;
              canvas.height = video.videoHeight;
              canvas.getContext('2d').drawImage(video, 0, 0, canvas.width, canvas.height);

              canvas.toBlob((blob) => {
                if (blob) {
                  const file = new File([blob], `thumbnail_${index}_${i}.jpg`, { type: 'image/jpeg' });
                  innerResolve(file); // Resolve the promise with the generated thumbnail file
                } else {
                  innerReject(new Error('Failed to create thumbnail blob')); // Reject if blob creation fails
                }
              }, 'image/jpeg', 0.9); // Adjust quality as needed
            };

            video.addEventListener('seeked', onSeeked, { once: true });
          });

          // Check if thumbnail generation was successful
          if (thumbnailFile && thumbnailFile.size > 1000) {
            thumbnails.push(thumbnailFile); // Store the generated thumbnail file
          } else {
            throw new Error('Invalid thumbnail generated'); // Throw an error to break the loop
          }
        }

        // Update state with the generated thumbnails using draftId as key
        setVideoThumbnails((prevThumbnails) => ({
          ...prevThumbnails,
          [file.draftId]: thumbnails // Store all generated thumbnails for the video
        }));

        // Convert the last thumbnail to base64 for state update
        const base64String = await convertToBase64(thumbnails[thumbnails.length - 1]);
        setVideoThumbnails64((prevThumbnails) => ({
          ...prevThumbnails,
          [file.draftId]: base64String // Update the last thumbnail as base64
        }));
        setThumbnailGenerationStatus((prev) => ({ ...prev, [file.draftId]: 'success' })); // Set success status
        resolve(); // Resolve the main promise
      } catch (error) {
        console.error('Thumbnail generation error:', error);
        setThumbnailGenerationStatus((prev) => ({ ...prev, [file.draftId]: 'failed' })); // Set failed status
        // If frontend thumbnail generation failed, fall back to backend API
let backendRetries = 0;
let backendSuccess = false;

while (backendRetries < 5 && !backendSuccess) {
  try {
    const videoFilePiece = new FormData();
    videoFilePiece.append('video_file', file.slice(0, 5 * 1024 * 1024)); // First 5MB
    videoFilePiece.append('draft_id', file.draftId); // First 5MB
    const apiUrl = 'https://uploader.projector.app/generate-thumbnail/';
// eslint-disable-next-line
    const response = await fetch(apiUrl, {
      method: 'POST',
      body: videoFilePiece,
    });
// eslint-disable-next-line
    const data = await response.json();

    if (data?.thumbnail) {
      const newThumbnailFile = base64ToFile(data.thumbnail, `thumbnail_${index}_backend.jpg`);

      setVideoThumbnails((prevThumbnails) => ({
        ...prevThumbnails,
        [file.draftId]: newThumbnailFile
      }));

      setVideoThumbnails64((prevThumbnails) => ({
        ...prevThumbnails,
        [file.draftId]: `data:image/png;base64, ${data.thumbnail}`
      }));

      setThumbnailGenerationStatus((prev) => ({
        ...prev,
        [file.draftId]: 'success',
      }));

      backendSuccess = true;
    } else {
      // eslint-disable-next-line
      backendRetries++;
      console.warn(`Backend thumbnail generation failed attempt ${backendRetries}`);
    }
  } catch (error) {
    // eslint-disable-next-line
    backendRetries++;
    console.error(`Error on backend retry ${backendRetries}:`, error);
  }
}

// If all backend retries failed
if (!backendSuccess) {
  setVideoThumbnails((prevThumbnails) => ({
    ...prevThumbnails,
    [file.draftId]: null
  }));

  setThumbnailGenerationStatus((prev) => ({
    ...prev,
    [file.draftId]: 'failed',
  }));
}
      }
    });

    video.addEventListener('error', (error) => {
      console.error('Error processing video:', error);
      setThumbnailGenerationStatus((prev) => ({ ...prev, [file.draftId]: 'failed' })); // Set failed status on error
    });

    // Timeout for thumbnail generation
    setTimeout(() => {
      setThumbnailGenerationStatus((prev) => ({ ...prev, [file.draftId]: 'success' }));
      resolve(); // Resolve in case of timeout
    }, 45000);
  });
};

function formatFileSize(sizeInBytes) {
  const kilobyte = 1024;
  const megabyte = kilobyte * 1024;
  const gigabyte = megabyte * 1024;
  if (sizeInBytes >= gigabyte) {
    return `${(sizeInBytes / gigabyte).toFixed(2)} GB`;
  }
  if (sizeInBytes >= megabyte) {
    return `${(sizeInBytes / megabyte).toFixed(2)} MB`;
  }
  if (sizeInBytes >= kilobyte) {
    return `${(sizeInBytes / kilobyte).toFixed(2)} KB`;
  }
  return `${sizeInBytes} Bytes`;
}
let dragCounter = 0;
const dragOver = (e) => {
  e.preventDefault();
  if (dragCounter === 0) {
  setDroper(true);
  }
// eslint-disable-next-line no-plusplus
  dragCounter++;
};
const dragLeave = (e) => {
// eslint-disable-next-line no-plusplus
  dragCounter--;
  e.preventDefault();
  if (dragCounter === 0) {
  setDroper(false);
  }
};
useEffect(() => {
  videoFiles.map((obj, i) => {
    const { draftId } = obj;
    const fileNameWithoutExtension = obj.name.split('.').slice(0, -1).join('.');

    if (test[draftId]) {
      updateTitle(draftId, test[draftId]);
    } else {
      updateTitle(draftId, fileNameWithoutExtension);
    }

    if (!videoThumbnails[obj.draftId] || videoThumbnails[obj.draftId].length < 2) {
      mediaThumGenerator(obj, i);
    }
    return false;
  });
  setT(true);
}, [videoFiles]);

const handleCheckboxChange = (name, size) => {
  setSelectedItemsInBulk((prevItems) => {
    const isSelected = prevItems.some((item) => item.name === name);
    if (isSelected) {
      return prevItems.filter((item) => item.name !== name);
    }
    return [
      ...prevItems,
      {
        token: getToken(),
        draftId: '',
        group_ids: [],
        thumbnails: '',
        name,
        description: '',
        category: '',
        playlist: [],
        visibility: '',
        size,
      },
    ];
  });
};

const handlePlaylistChange = (event, index) => {
  setSelectedItemsInBulk((prevItems) => {
    const newItems = [...prevItems];
    newItems[index] = {
      ...newItems[index],
      playlist: event.target.value,
    };
    return newItems;
  });
};

const handleCategoryChange = (event, index) => {
if (event.target.value !== undefined) {
  setAddingNewCategory((prevState) => {
    const updatedState = {};
    Object.keys(prevState).forEach((key) => {
      if (prevState[key] === true) {
        updatedState[key] = false;
      }
    });
    return updatedState;
  });
  const newCategoryStates = [...selectedItemsInBulk]; // Copy the current state
  const selectedCategoryValue = event.target.value;
  // Find the selected category name based on the value
  const selectedCategoryName = categrory.find(
    (categoryOption) => categoryOption.value === selectedCategoryValue
  )?.name || 'Default';

  // Always track the last selected category regardless of sync state
  setLastSelectedCategory({ value: selectedCategoryValue, name: selectedCategoryName });

  if (isSyncEnabled) {
    // If sync is enabled, apply the selected category to all items
    const updatedCategoryStates = newCategoryStates.map((item) => ({
      ...item,
      category: selectedCategoryValue,
      categoryName: selectedCategoryName,
    }));

    // Update the state and ChangeButton with the synced categories
    ChangeButton(updatedCategoryStates, videoFiles);
    setSelectedItemsInBulk(updatedCategoryStates);
  } else {
    // If sync is off, update only the selected item
    newCategoryStates[index] = {
      ...newCategoryStates[index],
      category: selectedCategoryValue,
      categoryName: selectedCategoryName,
    };

    // Update the state and ChangeButton with the updated individual category
    ChangeButton(newCategoryStates, videoFiles);
    setSelectedItemsInBulk(newCategoryStates);
  }
  setarrayUpdater(!arrayUpdater); // Trigger the re-render if needed
}
};

const handleInputChange = (e, index) => {
  e.preventDefault(); // Prevent default behavior
  setTitle(e.target.value);
};

const handleSubmit = async (e, index) => {
  setAddEditCategory(true);
  setIsSyncEnabled(false);
  e.preventDefault(); // Prevents page reload
  const payload = {
    category_id: '',
    icon: '1',
    title, // The text entered in the input field
    token: getToken(), // Assuming you have a getToken function
  };
  try {
    const response = await axios.post(`${baseUrl}/addEditCategory`, payload);
    fetchCategories();
    const { category_id, title: newCategoryName } = response.data; // Extract the new category details
    // After successful submission, update the selected category for the specific file
    setSelectedItemsInBulk((prevItems) => {
      const updatedItems = [...prevItems];
      updatedItems[index] = {
        ...updatedItems[index],
        category: category_id, // Use the new category ID from the response
        categoryName: title, // Use the new category name from the response
      };
      return updatedItems;
    });
    setLastSelectedCategory({ value: category_id, name: title });
    setAddingNewCategory((prev) => ({
      ...prev,
      [index]: false, // Update only the specific index
    }));
    setTitle('');
    setAddEditCategory(false);
    setCategoryRefreshTrigger((prev) => prev + 1);
  } catch (error) {
    console.error('Error:', error); // Handle error
    setAddEditCategory(false);
            setAppSnackbar({ isVisible: true, type: 'error', message: error?.response.data.message || 'Failed to add category' });
  }
};
const handleAddNewClick = (index) => {
  setIsSyncEnabled(false);

  // Close any open "Add New" inputs and open the clicked one
  setAddingNewCategory((prev) => {
    const newCategoryState = {};

    // Set all items to false except the one that was clicked
    Object.keys(prev).forEach((key) => {
      newCategoryState[key] = false;
    });
    newCategoryState[index] = true; // Open the clicked one
    return newCategoryState;
  });
};

const handleDescriptionChange = (event, index) => {
  const { value } = event.target;
  setSelectedItemsInBulk((prevItems) => prevItems.map((item, i) => (i === index ? { ...item, description: value } : item)));
};
const visibilityText = langText?.visibility;
const videoVisibilityOptions = [
  { name: 'All Viewers' || visibilityText?.publicDescription, value: '2' },
  { name: visibilityText?.privateDescription || 'Only I can view (Private)', value: '1' },
  { name: 'Choose a group', value: '3' },
];
const [openGroups, setOpenGroups] = useState(Array(selectedItemsInBulk.length).fill(false));

const handleVisibilityChange = (event, index) => {
  const newVisibilityStates = [...selectedItemsInBulk];
  newVisibilityStates[index] = {
    ...newVisibilityStates[index],
    visibility: event.target.value
  };
  const newOpenGroups = Array.isArray(openGroups) ? [...openGroups] : [];
  newOpenGroups[index] = event.target.value === '3';
  setSelectedItemsInBulk(newVisibilityStates);
  setOpenGroups(newOpenGroups);
};
const handleMenuItems = (index, i) => {
  const newOpenGroups = Array.isArray(openGroups) ? [...openGroups] : [];
  newOpenGroups[i] = true;
  if (index === 2) {
  setOpenGroups(newOpenGroups);
} else {
  setOpenGroups(false);
}
  };
const handleMenuItemClick = (index) => {
  const newOpenGroups = [...openGroups];
  newOpenGroups[index] = false;
  setOpenGroups(newOpenGroups);
};
const updateUploadPercentagesModal = (draft_id, data) => {
  dispatch(saveUploadInfo({ [draft_id]: data }));
};

  const updateDummy = (dummy, status = 0) => {
  if (status === 1) {
    dispatch(saveDummy({ [dummy?.draft_id]: dummy }));
  } else {
    dispatch(removeDummy(dummy));
  }
};
const handleEncouter = (draft_id) => {
  if (uploadQueue?.length <= 1) {
    if (photoList && photoList?.length > 0) {
      setActiveTab(1); // Switch to photo tab
    } else {
      setOpen(false); // Close modal only if no photos
    }
      }
  toast.update(draft_id, {
    closeButton: <CustomCloseloader />,
  });

  const databaseRef = ref(firebaseDatabase, 'status_from_sns');
  const changeFieldFromFirebase = (draft_id, statusString) => {
    const dataToUpdate = {
      [draft_id]: {
        status: statusString,
      },
    };
    update(databaseRef, dataToUpdate);
  };
  changeFieldFromFirebase(draft_id?.draft_id ? draft_id?.draft_id : draft_id, 'DELETED');
  updateDummy(draft_id?.draft_id ? draft_id?.draft_id : draft_id, 0);
  setIamUploading(false);
  setActiveUploads((prevUploads) => prevUploads?.filter((id) => id !== draft_id?.draft_id));
  setDraftOfUpload((prevUploads) => prevUploads?.filter((id) => id !== draft_id?.draft_id));
  setUploadContainer2((prevUploadContainer) => prevUploadContainer?.filter((id) => id !== draft_id?.draft_id));
  updateUploadPercentagesModal(draft_id?.draft_id ? draft_id?.draft_id : draft_id, 'Cancelled');
  closeToast(draft_id?.draft_id ? draft_id?.draft_id : draft_id, 'Upload has been canceled by user', 'error');
};

const backToOld = ({ draft_id, updateUploadPercentagesModal }) => {
  toast.update(draft_id, {
    closeButton: <CustomCloseButton draft_id={draft_id} updateUploadPercentagesModal={updateUploadPercentagesModal} />,
  });
};
const CustomCloseDiv = (draft_id, updateUploadPercentagesModal) => (
  <div className={styles.customDiv}>
    Are you sure you want to cancel ?
    <div className={styles.fleo}>
      <button className={styles.cancelPlz} onClick={() => backToOld(draft_id, updateUploadPercentagesModal)}>
      Exit
      </button>
      <button className={styles.noCancel} onClick={() => handleEncouter(draft_id)}>
        Continue to cancel
      </button>
    </div>
  </div>
);
const handleClick = (draft_id, updateUploadPercentagesModal) => {
  toast.update(draft_id, {
    closeButton: <CustomCloseDiv draft_id={draft_id} updateUploadPercentagesModal={updateUploadPercentagesModal} />,
  });
};
const CustomCloseloader = () => (
  <button className={styles.closeMeBro}>
  <Spinner />
  </button>
);

const CustomCloseButton = ({ draft_id }) => (
  <button className={styles.closeMeBro} onClick={() => handleClick(draft_id)}>
    <CloseIcon />
  </button>
);

function changeSize(size) {
  const newSize = size / 1024 / 1024;
  return newSize.toFixed(2);
}

async function handleInitMultipartUpload() {
  // Switch to tab 1 to ensure dummy objects are visible
  setTabTitle(0);
  // setOpen(false);
  setSelectedFiles([]);
  setDraftOfUpload([]);
  videoFiles.forEach((file, index) => {
    const fileExtension = file.name.split('.').pop().toLowerCase();
    const number = Math.floor(Math.random() * 10000) + 1;
    const fileName = `${Date.now()}-${userId}-video-${number}.${fileExtension}`;
    // Add file to the upload queue
    setUploadQueue((prevQueue) => [
      ...prevQueue,
      { file, index, fileName, draftId: file.draftId }
    ]);
    setDraftOfUpload((prevDraftIds) => [...prevDraftIds, file.draftId]);
    const currentDate = new Date();
    const date = currentDate.getDate();
    const month = currentDate.getMonth() + 1;
    const year = currentDate.getFullYear();
    const formattedDate = `${String(month).padStart(2, '0')}/${String(date).padStart(2, '0')}/${year}`;
    const type_of = 0;
    const contentStatus = 'Video';
    const dummy = {
      draft_id: file.draftId,
      title: test[file.draftId] || fileName,
      thumbnail: videoThumbnails64[file.draftId] || ForNoImage,
      category: selectedItemsInBulk[index].categoryName,
      video_description: selectedItemsInBulk[index].description,
      created: formattedDate,
      video_size: changeSize(file?.size),
      type: type_of,
      group_id: selectedItemsInBulk[index]?.group_ids,
      content_status: contentStatus,
      uploadIsTrying: 1,
    };
    updateDummy(dummy, 1);
  });
  processUploadQueue();
  setOpen();
  if (photoList && photoList?.length > 0) {
    setActiveTab(1); // Switch to photo tab, keep modal visible
  } else {
    // setIsVisible(false);
  }
  setNavigateOnceClicked(true);
  // setTimeout(() => {
  // }, 300);
      navigateToInviteFirstTime();
}

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};
const handleDelete = (id, index) => {
  // Remove thumbnails by draftId
  setVideoThumbnails((prevThumbnails) => {
    const updatedThumbnails = { ...prevThumbnails };
    delete updatedThumbnails[id];
    return updatedThumbnails;
  });

  setVideoThumbnails64((prevThumbnails64) => {
    const updatedThumbnails64 = { ...prevThumbnails64 };
    delete updatedThumbnails64[id];
    return updatedThumbnails64;
  });
  updateTitle(index, null, 0);
  const updatedSelectedItems = selectedItemsInBulk.filter((item) => item?.draftId !== id);
  setSelectedItemsInBulk(updatedSelectedItems);
  const updatedVideoFiles = videoFiles.filter((file) => file.draftId !== id);
  setVideoFiles(updatedVideoFiles);
  setVideoGroup((prevVideoGroup) => {
    const updatedVideoGroup = [...prevVideoGroup];
    updatedVideoGroup.splice(index, 1);
    return updatedVideoGroup;
  });
  if (updatedVideoFiles.length === 0) {
    if (photoList && photoList.length > 0) {
      setActiveTab(1); // Switch to photo tab
    } else {
      setOpen(false); // Close modal only if no photos
    }
  }
  ChangeButton(selectedItemsInBulk, updatedVideoFiles);
  setarrayUpdater(!arrayUpdater);
};
const [inputTrigger, setInputTrigger] = useState(false);

const MAX_SIZE_BYTES = MAX_SIZE_GB * 1024 * 1024 * 1024;
const allowedVideoExtensions = ['mp4', 'mov', 'mpg', 'm4v', 'm2ts'];
const allowedPhotoExtensions = ['jpg', 'jpeg', 'png', 'webp', 'bmp'];

const handleVideoFileChange = (event) => {
  dragCounter = 0;
  setDroper(false);
  event.preventDefault();

  const newFiles = Array.from(event.dataTransfer?.files || event.target.files);

  newFiles.forEach((file) => {
    // eslint-disable-next-line
    file.draftId = uuid();
    // eslint-disable-next-line
    file.visibility = '2';
  });

  // Validate video file formats
  const invalidFiles = newFiles.filter((file) => {
    const extension = file.name.split('.').pop().toLowerCase();
    return !allowedVideoExtensions.includes(extension);
  });

  if (invalidFiles.length > 0) {
    setAppSnackbar({ isVisible: true, type: 'error', message: 'Invalid file format. Allowed formats are: .mp4, .mov, .mpg, .m4v, .m2ts' });
    return;
  }

  const combinedFiles = [...videoFiles, ...newFiles];
  const totalSize = combinedFiles.reduce((acc, file) => acc + file.size, 0);
  const remainingUploads = ALLOWED_UPLOADS_COUNT - userDetails?.totalContentUploaded;

  if (userDetails?.isSubscription === null && combinedFiles.length > remainingUploads) {
    setAppSnackbar({
      isVisible: true,
      type: 'error',
      message: `You can only upload ${remainingUploads - videoFiles.length} videos`
    });
    return;
  }

  if (combinedFiles.length > MAX_VIDEOS) {
    setAppSnackbar({ isVisible: true, type: 'error', message: `You can only select ${MAX_VIDEOS} videos` });
    return;
  }

  if (totalSize > MAX_SIZE_BYTES) {
    setAppSnackbar({ isVisible: true, type: 'error', message: `Total file size should not exceed ${MAX_SIZE_GB}GB.` });
    return;
  }

  // Update state with valid video files
  setSelectedItemsInBulk((prevItems) => [
    ...prevItems,
    ...newFiles.map((file) => ({
      token: getToken(),
      group_ids: [],
      draftId: file.draftId,
      thumbnails: '',
      name: file.name,
      description: '',
      category: '',
      playlist: [],
      visibility: file.visibility,
      size: file.size,
    })),
  ]);

  setVideoFiles((prevFiles) => [...prevFiles, ...newFiles]);
  ChangeButton(combinedFiles, null, 'singleArray');
  setIsSyncEnabled(false);

  // Clear the file input to allow selecting the same files again or new files
  if (event.target) {
    // eslint-disable-next-line
    event.target.value = '';
  }
};

const handlePhotoFileChange = (event) => {
  event.preventDefault();

  const newFiles = Array.from(event.dataTransfer?.files || event.target.files);

  // Validate photo file formats
  const invalidFiles = newFiles.filter((file) => {
    const extension = file.name.split('.').pop().toLowerCase();
    return !allowedPhotoExtensions.includes(extension);
  });

  if (invalidFiles.length > 0) {
    setAppSnackbar({
      isVisible: true,
      type: 'error',
      message: 'Invalid file format. Allowed formats are: .jpg, .jpeg, .png, .webp, .bmp'
    });
    return;
  }

  // Convert files to URLs for display
  const photoUrls = newFiles.map((file) => URL.createObjectURL(file));

  setPhotoList((prevPhotos) => [...(prevPhotos || []), ...photoUrls]);

  setAppSnackbar({
    isVisible: true,
    type: 'success',
    message: `${newFiles.length} photo(s) added successfully`
  });

  // Clear the file input to allow selecting the same files again or new files
  if (event.target) {
     // eslint-disable-next-line
    event.target.value = '';
  }
};

const groupRefs = useRef([]);
const setGroupRef = (index) => (element) => {
  groupRefs.current[index] = element;
};

const label = { inputProps: { 'aria-label': 'Select all' } };
useEffect(() => {
  function handleClickOutside(event) {
    // setAddingNewCategory((prevState) => {
    //   const updatedState = { ...prevState }; // Copy previous state
    //   Object.keys(prevState).forEach((key) => {
    //     if (prevState[key] === true) {
    //       updatedState[key] = false; // Only set true values to false
    //     }
    //   });
    //   return updatedState;
    // });
    groupRefs.current.forEach((ref, index) => {
      if (ref && !ref.contains(event.target)) {
        const newOpenGroups = [...openGroups];
        newOpenGroups[index] = false;
        setOpenGroups(newOpenGroups);
      }
    });
  }
  document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
}, [openGroups, setOpenGroups]);
console.log('selectedItemsInBulk', selectedItemsInBulk);

  // Tools section handlers
  const handleClearAllTitles = () => {
    const updatedItems = { ...test };
    videoFiles.forEach((file) => {
      updatedItems[file.draftId] = '';
    });
    videoFiles.forEach((file) => {
      updateTitle(file.draftId, '');
    });
  };

  const handleClearAllDescriptions = () => {
    setSelectedItemsInBulk((prevItems) => prevItems.map((item) => ({ ...item, description: '' })));
  };

  const [applyCategoryDialogOpen, setApplyCategoryDialogOpen] = useState(false);
  const [selectedCategoryForAll, setSelectedCategoryForAll] = useState('');

  const handleApplyCategoryToAll = () => {
    if (selectedCategoryForAll) {
      const selectedCat = categrory?.find((cat) => cat.value === selectedCategoryForAll);
      if (selectedCat) {
        const updatedItems = selectedItemsInBulk.map((item) => ({
          ...item,
          category: selectedCat.value,
          categoryName: selectedCat.name
        }));
        setSelectedItemsInBulk(updatedItems);
        ChangeButton(updatedItems, videoFiles);
        setApplyCategoryDialogOpen(false);
      }
    }
  };

  const [applyVisibilityDialogOpen, setApplyVisibilityDialogOpen] = useState(false);
  const [selectedVisibilityForAll, setSelectedVisibilityForAll] = useState('2');
  const [photoTitle, setPhotoTitle] = useState('');
  const [photoDescription, setPhotoDescription] = useState('');
  const [photoVisibility, setPhotoVisibility] = useState('2');
  const [photoOpenGroups, setPhotoOpenGroups] = useState(false);
  const [selectedPhotoThumbnail, setSelectedPhotoThumbnail] = useState(photoList[0]?.thumbnail);

  const handleFileChange = (event) => {
    if (activeTab === 0) {
      handleVideoFileChange(event);
    } else {
      handlePhotoFileChange(event);
    }
  };

  const handlePhotoVisibilityChange = (event) => {
    setPhotoVisibility(event.target.value);
    setPhotoOpenGroups(event.target.value === '3');
  };

  const handlePhotoMenuItems = (index) => {
    if (index === 2) {
      setPhotoOpenGroups(true);
    } else {
      setPhotoOpenGroups(false);
    }
  };

  const selectPhotoGroup = (val) => {
    // Handle photo group selection logic here
    console.log('Photo group selected:', val);
  };

  // Helper function to convert file to base64
  const fileToBase64 = (file) => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

  const handlePhotoPublish = async () => {
    if (!photoTitle.trim() || !photoDescription.trim()) {
      setAppSnackbar({
        isVisible: true,
        type: 'error',
        message: 'Please fill in both title and description before publishing.'
      });
      return;
    }

    if (!photoList || photoList.length === 0) {
      setAppSnackbar({
        isVisible: true,
        type: 'error',
        message: 'Please add photos before publishing.'
      });
      return;
    }

    if (!selectedPhotoThumbnail) {
      setAppSnackbar({
        isVisible: true,
        type: 'error',
        message: 'Please select a thumbnail for your album.'
      });
      return;
    }

    setIsLoading(true);

    try {
      // Step 1: First call addEditAlbum API to create album and get album_id
      const albumPayload = {
        title: photoTitle.trim(),
        description: photoDescription.trim()
      };

      const albumResponse = await axios.post(`${baseUrl}/${endpoints.addEditAlbum}`, albumPayload, {
        headers: {
          Authorization: `Bearer ${getToken()}`
        }
      });

      if (!albumResponse.data || !albumResponse.data.success) {
        throw new Error(albumResponse.data?.message || 'Failed to create album');
      }

      const albumId = albumResponse.data.album_id;

      // Step 2: Convert photos to binary data (base64)
      const photoFiles = [];

      // Get the original files from photoList
      for (let i = 0; i < photoList.length; i += 1) {
        const photo = photoList[i];
        if (photo.originalFile) {
          photoFiles.push(photo.originalFile);
        }
      }

      // Convert selected thumbnail to base64
      let thumbnailBase64 = '';
      if (selectedPhotoThumbnail) {
        // Find the original file for the selected thumbnail
        const selectedPhoto = photoList.find((photo) => photo.thumbnail === selectedPhotoThumbnail);
        if (selectedPhoto && selectedPhoto.originalFile) {
          thumbnailBase64 = await fileToBase64(selectedPhoto.originalFile);
        }
      }

      // Step 3: Create FormData for addPhotoContent API call
      const formData = new FormData();
      formData.append('token', getToken());
      formData.append('album_id', albumId); // Use album_id from addEditAlbum response
      formData.append('title', photoTitle.trim());
      formData.append('description', photoDescription.trim());
      formData.append('visibility', photoVisibility);

      if (thumbnailBase64) {
        formData.append('icon', thumbnailBase64);
      }

      // Add all photo files as binary
      photoFiles.forEach((file) => {
        formData.append('photos[]', file);
      });

      // Add group IDs if visibility is set to group
      if (photoVisibility === '3') {
        // Add group selection logic here if needed
        formData.append('group_ids', '[]');
      }

      const response = await addPhotoContent(formData);

      if (response.data && response.data.success) {
        setAppSnackbar({
          isVisible: true,
          type: 'success',
          message: 'Photo album published successfully!'
        });

        // Reset form
        setPhotoTitle('');
        setPhotoDescription('');
        setPhotoVisibility('2');
        setSelectedPhotoThumbnail(null);
        setPhotoList([]);

        // Close modal and hide it
        setOpen(false);
        // setIsVisible(false);
      } else {
        throw new Error(response.data?.message || 'Failed to publish photo album');
      }
    } catch (error) {
      console.error('Error publishing photo album:', error);
      setAppSnackbar({
        isVisible: true,
        type: 'error',
        message: error.message || 'Failed to publish photo album. Please try again.'
      });
    } finally {
      // setIsVisible(false);
      setIsLoading(false);
    }
  };

  const handleApplyVisibilityToAll = () => {
    const updatedItems = selectedItemsInBulk.map((item) => ({
      ...item,
      visibility: selectedVisibilityForAll
    }));
    setSelectedItemsInBulk(updatedItems);
    if (selectedVisibilityForAll === '3') {
      setOpenGroups(new Array(selectedItemsInBulk.length).fill(true));
    } else {
      setOpenGroups(new Array(selectedItemsInBulk.length).fill(false));
    }
    setApplyVisibilityDialogOpen(false);
  };

  const handleResetAll = () => {
    // Reset titles to original file names
    videoFiles.forEach((file) => {
      const fileNameWithoutExtension = file.name.split('.').slice(0, -1).join('.');
      updateTitle(file.draftId, fileNameWithoutExtension);
    });

    // Reset all other fields
    const resetItems = videoFiles.map((file) => ({
      token: getToken(),
      group_ids: [],
      draftId: file.draftId,
      thumbnails: '',
      name: file.name,
      description: '',
      category: findAllVideoCategory?.value || '',
      categoryName: findAllVideoCategory?.name || '',
      playlist: [],
      visibility: '2',
      size: formatFileSizeAccMb(file.size)
    }));
    setSelectedItemsInBulk(resetItems);
    setOpenGroups(new Array(videoFiles.length).fill(false));
    setIsSyncEnabled(false);
  };

  return (
    <div
    onDrop={handleFileChange}
    onDragOver={(e) => dragOver(e)}
    onDragLeave={(e) => dragLeave(e)}
    // style={{
    //   display: isVisible ? 'block' : 'none',
    // }}
      className={styles.positioningModel}
      onKeyPress={undefined}
      role="button"
      tabIndex={0}
      // onClick={(event) => handleClose(event)}
    >
      {droper
&& (
<div
  role="button" // Adds the appropriate role
  tabIndex={0} // Makes it focusable by keyboard
  onClick={() => { setDroper(false); dragCounter = 0; }}
  onKeyPress={(event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      dragCounter = 0; // Also handles Enter/Space key press for accessibility
    }
  }}
  className={styles.bigCover}
>
  <img className={styles.imgCenter} src={CloudUpl} alt="" />
</div>

)}
      <div
        onKeyPress={undefined}
        role="button"
        tabIndex={0}
        onClick={(event) => {
          event.stopPropagation();
          // if (Object.values(addingNewCategory).some((value) => value === true)) {
          //   setAddingNewCategory((prevState) => {
          //     const updatedState = {};
          //     Object.keys(prevState).forEach((key) => {
          //       if (prevState[key] === true) {
          //         updatedState[key] = false;
          //       }
          //     });
          //     return updatedState;
          //   });
          // }
        }}
        className={styles.bringCenter}
      >
        <div className={styles.heading}>
          {((videoFiles?.length > 0 && photoList?.length > 0 && activeTab === 0) || (videoFiles?.length > 0 && (!photoList || photoList?.length === 0))) ? (
            <>
Videos will be published to
{' '}
<strong>{defaultCategoryName}</strong>
{' '}
unless category is selected
            </>
          ) : 'Create a Photo Album'}
        </div>
        <div className={styles.headingh3}>
          <div>{((videoFiles?.length > 0 && photoList?.length > 0 && activeTab === 0) || (videoFiles?.length > 0 && (!photoList || photoList?.length === 0))) ? 'To Add Subcategory, Change Thumbnail, And Add Video Description, Edit In Content Dashboard>Content' : 'Select from your photo collection to create an album'}</div>
          <span style={{ fontSize: '14px', fontWeight: '600' }}>
            {((videoFiles?.length > 0 && photoList?.length > 0 && activeTab === 0) || (videoFiles?.length > 0 && (!photoList || photoList?.length === 0))) ? `${selectedItemsInBulk?.length} Videos added` : 'Photo Album'}
          </span>
        </div>
{videoFiles?.length > 0 && photoList?.length > 0 && (
        <div className={styles.tabContainer}>
          <Tabs
            value={activeTab}
            onChange={(event, newValue) => setActiveTab(newValue)}
            className={styles.tabs}
            indicatorColor="primary"
            textColor="primary"
            variant="fullWidth"
          >
            <Tab label="Videos" className={styles.tab} />
            <Tab label="Photos" className={styles.tab} />
          </Tabs>
        </div>
        )}
        <hr className={styles.linex} />
        <div className={styles.overScrollMe}>
        {((videoFiles?.length > 0 && photoList?.length > 0 && activeTab === 0) || (videoFiles?.length > 0 && (!photoList || photoList?.length === 0))) ? (
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
          <TableRow>
            {/* <TableCell>
              <Checkbox
              status={selectedItemsInBulk?.length === videoFiles?.length}
              />
            </TableCell> */}
            <TableCell>
              <div className={styles.TbleCel}>
              Content Preview
              </div>
            </TableCell>
            <TableCell className={styles.TbleCel}>
              <div className={styles.TbleCel}>
                Video Title
              </div>
            </TableCell>
            {/* <TableCell>
              Description
            </TableCell> */}
            <TableCell className={styles.TbleCel}>
              <div className={styles.TbleCel}>
            Category
              </div>
            </TableCell>
            {/* <TableCell>
              Playlist
            </TableCell> */}
            <TableCell className={styles.TbleCel}>
              <div className={styles.TbleCel}>
              Visiblity
              </div>
            </TableCell>
            <TableCell className={styles.TbleCel}>
              <div className={styles.TbleCel}>
              Size
              </div>
            </TableCell>
            <TableCell className={styles.TbleCel}>
              <div className={styles.TbleCel}>
              Actions
              </div>
            </TableCell>
          </TableRow>
          </TableHead>
         { t === true ? (
            <TableBody>
            {videoFiles?.map((obj, i) => (
              <TableRow key="" sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                {/* <TableCell>
                  <Checkbox
                    status={selectedItemsInBulk?.some((item) => item?.name === obj?.name)}
                    onClick={() => handleCheckboxChange(obj?.name, obj?.size)}
                  />
                </TableCell> */}
                <TableCell>
                <video ref={videoRef} style={{ display: 'none' }} controls />
                <div className={styles.previewContainer}>
                {(() => {
                  const thumbnailStatus = thumbnailGenerationStatus[obj.draftId];

                  // Show loader/shimmer while generating
                  if (thumbnailStatus === 'generating') {
                    return (
                      <div className={styles.thumbnailLoader}>
                        <img
                          className={styles.previewImage}
                          src={generatingThumbnail}
                          alt="Generating thumbnail..."
                          style={{ opacity: 0.7 }}
                        />
                        <div className={styles.shimmerOverlay} />
                      </div>
                    );
                  }

                  // Show actual thumbnail if available
                  if (videoThumbnails[obj.draftId]) {
                    return (
                      <img
                        className={styles.previewImage}
                        src={(() => {
                          try {
                            return URL.createObjectURL(videoThumbnails[obj.draftId][0]);
                          } catch (error) {
                            console.error('Failed to create object URL:', error);
                            return videoThumbnails64?.[obj.draftId] ?? noImageAvailable;
                          }
                        })()}
                        alt={obj?.title}
                      />
                    );
                  }

                  // Show ForNoImage only if generation failed
                  if (thumbnailStatus === 'failed') {
                    return (
                      <img
                        style={{ objectFit: 'contain' }}
                        className={styles.previewImage}
                        src={ForNoImage}
                        alt={obj?.title}
                      />
                    );
                  }

                  // Default loading state (before generation starts)
                  return (
                    <div className={styles.thumbnailLoader}>
                      <div className={styles.shimmerPlaceholder} />
                    </div>
                  );
                })()}
                </div>
                </TableCell>
                <TableCell component="th" scope="row">
                  <div className={styles.nameBal}>
                      <input maxLength={70} type="text" placeholder="Title" value={test[obj.draftId]} onChange={(e) => updateTitle(obj.draftId, e.target.value)} className={styles.titles} />
                  </div>
                </TableCell>
                {/* <TableCell component="th" scope="row">
                <textarea className={styles.description} placeholder="Description" value={selectedItemsInBulk?.length > 0 ? selectedItemsInBulk[i]?.description : ''} onChange={(e) => handleDescriptionChange(e, i)} />
                </TableCell> */}
<TableCell sx={{ width: '233px', textAlign: 'center' }}>
                {categrory !== undefined
                  ? (addingNewCategory[i] ? (
                    // Show input form when adding a new category
                    <form className={styles.addnewForm} onSubmit={(e) => handleSubmit(e, i)}>
<button
  onClick={() => {
    setTitle('');
 setAddingNewCategory((prevState) => {
    const updatedState = { ...prevState }; // Copy previous state
    Object.keys(prevState).forEach((key) => {
      if (prevState[key] === true) {
        updatedState[key] = false; // Only set true values to false
      }
    });
    return updatedState;
  });
}}
  style={{
    background: 'transparent',
  }}
>
  <CloseIcon />
</button>

                      <input
                        type="text"
                        value={title}
                        className={styles.titles}
                        onChange={handleInputChange}
                        placeholder="Enter Category"
                        maxLength={70}
                      />
                      <button
style={{
    opacity: title === '' ? '0' : '1',
    cursor: title === '' ? 'not-allowed' : 'pointer' // Optional: change cursor based on button state
  }}
disabled={title === ''}
type="submit"
                      >
                      {addEditCategory ? (
  <Spinner spinex={spinerSmall} />
) : (
  'Add'
)}
                      </button>
                    </form>
                  ) : (
<div className={styles.tabletC}>
<button style={{ opacity: '0' }}>
<CloseIcon />
</button>
<FormControl key={i} sx={{ m: 1, width: 120, background: selectedItemsInBulk[i]?.categoryName === 'All Videos' ? 'rgba(90, 165, 239, 0.4)' : 'transparent' }}>
                    <InputLabel
                      htmlFor={`category-select-${i}`}
                      color="primary"
                    >
                      {categrory?.length < 0 ? 'No Category' : 'Category'}
                    </InputLabel>
                    <Select
                    onClick={(e) => handleCancel(e, i)}
                    value={selectedItemsInBulk[i]?.category ?? findAllVideoCategory?.value}
                      onChange={(e) => handleCategoryChange(e, i)}
                      input={<OutlinedInput label="category" />}
                      displayEmpty
                      inputProps={{ 'aria-label': 'Without label' }}
                    >
                  <MenuItem
                  disableRipple
                  disableTouchRipple
                  onClick={() => handleAddNewClick(i)}
                  sx={{ color: '#5AA5EF', fontWeight: 500 }}
                  >
                  <Typography variant="inherit" noWrap>Add new</Typography>
                  </MenuItem>
                      {categrory?.length > 0
                        && categrory.map((categoryOption, index) => (
                          <MenuItem key={index} value={categoryOption.value || index + 1}>
                            {categoryOption.name || 'Default Name'}
                          </MenuItem>
                        ))}
                    </Select>
</FormControl>
<button style={{ opacity: '0' }}>
<CloseIcon />
</button>
</div>
                  )
                  )
                : <Spinner spinex={spinerSmall} />}
</TableCell>
                {/* <TableCell>
                    {options?.length > 0 ? (
                      <FormControl sx={{ m: 1, width: 200 }}>
                         <InputLabel htmlFor={`playlist-select-${i}`} color="primary">Playlist</InputLabel>
                        <Select
                          labelId="demo-multiple-checkbox-label"
                          id="demo-multiple-checkbox"
                          multiple
                          value={selectedItemsInBulk[i]?.playlist}
                          onChange={(e) => handlePlaylistChange(e, i)}
                          input={<OutlinedInput label="Playlist" />}
                          renderValue={(selected) => selected.map((item) => item.name).join(', ')}
                          MenuProps={MenuProps}
                        >
                          {selectedItemsInBulk[i]?.playlist?.length <= 0 && ( // Render the placeholder only when no playlist is selected
                            <MenuItem value="" disabled>
                              Select Playlist
                            </MenuItem>
                          )}
                          {options && options?.map((option, index) => (
                            <MenuItem key={index} value={option || index + 1}>
                              <StyledCheckbox
                                checked={selectedItemsInBulk[i]?.playlist?.includes(option) || false}
                              />
                              <ListItemText primary={option?.name || 'Default Name'} />
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    ) : <Spinner spinex={spinerSmall} />}

                </TableCell> */}
                <TableCell>
                  <div className={styles.visibilityContainer}>
                       <FormControl sx={{ m: 1, width: 180 }}>
                          <Select
                            value={selectedItemsInBulk[i]?.visibility || '2'}
                            onChange={(e) => handleVisibilityChange(e, i)}
                            inputProps={{ 'aria-label': 'Without label' }}
                          >
                          {videoVisibilityOptions?.map((option, index) => (
                            <MenuItem onClick={() => handleMenuItems(index, i)} key={index} value={option?.value || index + 1}>
                              {option?.name || 'Default Name'}
                            </MenuItem>
                          ))}
                          </Select>
                       </FormControl>
                        {/* {selectedItemsInBulk[i].visibility === videoVisibilityOptions[2].value && ( */}
                        {openGroups[i] && (
                          <div ref={setGroupRef(i)}>
                            <GroupSelector
                              isBulk
                              onSelect={(val) => { selectGroup(val, i); }}
                              selectedOption={selectedItemsInBulk[i]?.group_ids || []}
                              setOpenGroups={setOpenGroups}
                              handleMenuItemClick={handleMenuItemClick}
                              index={i}
                            />
                          </div>
                        )}
                  </div>
                </TableCell>
                <TableCell>
                  <div className={styles.sizeBal}>
                {formatFileSize(obj.size)}
                  </div>
                </TableCell>
                <TableCell>
                {/* <div style={{ backgroundColor: 'none', cursor: 'pointer', width: 'auto', height: 'auto' }} > */}
                <button disabled={isLoading} onClick={() => !isLoading && handleDelete(obj.draftId, i)} style={{ backgroundColor: 'transparent', cursor: isLoading ? 'default' : 'pointer', opacity: isLoading ? '0.5' : '1' }}>
                  <img src={DeleteIcon} alt="Remove" style={{ height: '25px', width: '25px' }} />
                </button>
                </TableCell>
              </TableRow>
            ))}
            </TableBody>
            )
            : (null) }
          </Table>
        </TableContainer>
        ) : (
          <div className={styles.photoSection}>
            {/* Top Section - 50/50 Layout */}
            <div className={styles.photoTopSection}>
              {/* Left - Thumbnail Preview (50%) */}
              <div className={styles.selectedThumbnailContainer}>
                <div className={styles.thumbnailPreview}>
                  {selectedPhotoThumbnail ? (
                    <img
                      src={selectedPhotoThumbnail}
                      alt="Selected thumbnail"
                      className={styles.selectedThumbnailImage}
                    />
                  ) : (
                    <div className={styles.placeholderThumbnail}>
                      <span>Select a photo as thumbnail</span>
                    </div>
                  )}
                </div>
                <span className={styles.thumbnailLabel}>Album Thumbnail</span>
              </div>

              {/* Right - Controls (50%) */}
              <div className={styles.photoControls}>
                <div className={styles.controlGroup}>
                  <TextField
                    label="Album Title"
                    value={photoTitle}
                    onChange={(e) => setPhotoTitle(e.target.value)}
                    className={styles.titleInput}
                    variant="outlined"
                    fullWidth
                    placeholder="Enter album title..."
                  />
                </div>

                <div className={styles.controlGroup}>
                  <TextField
                    label="Album Description"
                    multiline
                    rows={3}
                    value={photoDescription}
                    onChange={(e) => setPhotoDescription(e.target.value)}
                    className={styles.descriptionInput}
                    variant="outlined"
                    fullWidth
                    placeholder="Describe your photo album..."
                  />
                </div>

                <div className={styles.controlGroup}>
                  <div className={styles.visibilityContainer}>
                    <FormControl sx={{ m: 1, width: 252 }}>
                      <Select
                        value={photoVisibility}
                        onChange={(e) => handlePhotoVisibilityChange(e)}
                        inputProps={{ 'aria-label': 'Without label' }}
                      >
                        {videoVisibilityOptions?.map((option, index) => (
                          <MenuItem onClick={() => handlePhotoMenuItems(index)} key={index} value={option?.value || index + 1}>
                            {option?.name || 'Default Name'}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    {photoOpenGroups && (
                      <div>
                        <GroupSelector
                          isBulk
                          onSelect={(val) => { selectPhotoGroup(val); }}
                          selectedOption={[]}
                          setOpenGroups={setPhotoOpenGroups}
                          handleMenuItemClick={() => {}}
                          index={0}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>

            {/* Bottom Section - Full Width Thumbnail Grid */}
            <div className={styles.photoThumbnailSection}>
              <h4 className={styles.photoListTitle}>Choose from your photos (Select up to 5)</h4>
              <div className={styles.photoSelectionGrid}>
                {console.log('photoList', photoList)}
                {photoList && photoList.slice(0, 5)?.map((photo, index) => (
                  <div
                    key={index}
                    className={`${styles.photoItem} ${selectedPhotoThumbnail === photo?.thumbnail ? styles.selectedPhoto : ''}`}
                    onClick={() => setSelectedPhotoThumbnail(photo?.thumbnail)}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter' || e.key === ' ') {
                        setSelectedPhotoThumbnail(photo?.thumbnail);
                      }
                    }}
                    role="button"
                    tabIndex={0}
                  >
                    <img
                      src={photo?.thumbnail}
                      alt={`${index + 1}`}
                      className={styles.photoThumbnail}
                    />
                    {selectedPhotoThumbnail === photo?.thumbnail && (
                      <div className={styles.selectedOverlay}>
                        <CheckIcon className={styles.checkIcon} />
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
        </div>
      <div className={styles.flexico}>
        {/* Tools Section */}
        <div className={styles.toolsSection}>
          <span className={styles.toolsLabel}>Tools</span>
          <div className={styles.toolsDivider} />
          <Tooltip title="Clear all titles">
            <button
              className={styles.toolButton}
              onClick={handleClearAllTitles}
            >
              <TitleIcon className={styles.toolIcon} />
            </button>
          </Tooltip>
          {/* <Tooltip title="Clear all descriptions">
            <button
              className={styles.toolButton}
              onClick={handleClearAllDescriptions}
            >
              <DescriptionIcon className={styles.toolIcon} />
            </button>
          </Tooltip> */}
          <Tooltip title="Apply same category to all videos">
            <button
              className={styles.toolButton}
              onClick={() => setApplyCategoryDialogOpen(true)}
            >
              <CategoryIcon className={styles.toolIcon} />
            </button>
          </Tooltip>
          <Tooltip title="Apply same visibility to all videos">
            <button
              className={styles.toolButton}
              onClick={() => setApplyVisibilityDialogOpen(true)}
            >
              <VisibilityIcon className={styles.toolIcon} />
            </button>
          </Tooltip>
          <Tooltip title="Reset all to original values">
            <button
              className={styles.toolButton}
              onClick={handleResetAll}
            >
              <RefreshIcon className={styles.toolIcon} />
            </button>
          </Tooltip>
        </div>
{(
  // Show Add Videos button when: tabs are visible and activeTab is 0, OR when only videos exist
  (((videoFiles?.length > 0 && photoList?.length > 0 && activeTab === 0) || (videoFiles?.length > 0 && (!photoList || photoList?.length === 0)))
   && videoFiles.length < MAX_VIDEOS && !(
    userDetails?.isSubscription === null
    && videoFiles.length === (ALLOWED_UPLOADS_COUNT - userDetails?.totalContentUploaded)
   ))
  // Show Add Photos button when: tabs are visible and activeTab is 1, OR when only photos exist
  || ((videoFiles?.length > 0 && photoList?.length > 0 && activeTab === 1) || ((!videoFiles || videoFiles?.length === 0) && photoList?.length >= 0))
) && (
  <div className={styles.flexButton}>
    <label htmlFor="file-upload" className={styles.labelButton}>
      {((videoFiles?.length > 0 && photoList?.length > 0 && activeTab === 0) || (videoFiles?.length > 0 && (!photoList || photoList?.length === 0))) ? 'Add Videos' : 'Add Photos'}
    </label>
    <input
      onChange={handleFileChange}
      type="file"
      accept={((videoFiles?.length > 0 && photoList?.length > 0 && activeTab === 0) || (videoFiles?.length > 0 && (!photoList || photoList?.length === 0))) ? 'video/*' : 'image/*'}
      multiple
      id="file-upload"
      className={styles.hiddenInput}
    />
  </div>
)}

        <div className={styles.flexButtun}>
          <button
          onClick={() => { setOpen(false); setSelectedFiles([]); }}
          className={styles.cancel}
          >
            Cancel
          </button>
          <button
            disabled={((videoFiles?.length > 0 && photoList?.length > 0 && activeTab === 0) || (videoFiles?.length > 0 && (!photoList || photoList?.length === 0))) ? isLoading : (isLoading || !photoTitle.trim() || !photoDescription.trim())}
            className={styles.save}
            style={{
              cursor: (((videoFiles?.length > 0 && photoList?.length > 0 && activeTab === 0) || (videoFiles?.length > 0 && (!photoList || photoList?.length === 0))) ? isLoading : (isLoading || !photoTitle.trim() || !photoDescription.trim())) ? 'default' : 'pointer',
              opacity: (((videoFiles?.length > 0 && photoList?.length > 0 && activeTab === 0) || (videoFiles?.length > 0 && (!photoList || photoList?.length === 0))) ? isLoading : (isLoading || !photoTitle.trim() || !photoDescription.trim())) ? '0.5' : '1'
            }}
            onClick={((videoFiles?.length > 0 && photoList?.length > 0 && activeTab === 0) || (videoFiles?.length > 0 && (!photoList || photoList?.length === 0)))
              ? (!isLoading && handleInitMultipartUpload)
              : (!isLoading && !(!photoTitle.trim() || !photoDescription.trim()) && handlePhotoPublish)}
          >
            {((videoFiles?.length > 0 && photoList?.length > 0 && activeTab === 0) || (videoFiles?.length > 0 && (!photoList || photoList?.length === 0))) ? buttonText : 'Publish Album'}
          </button>
        </div>
      </div>
      </div>

      {/* Apply Category Dialog */}
      <Dialog open={applyCategoryDialogOpen} onClose={() => setApplyCategoryDialogOpen(false)}>
        <DialogTitle>Apply Category to All Videos</DialogTitle>
        <DialogContent>
          <MuiFormControl fullWidth sx={{ mt: 2 }}>
            <MuiInputLabel>Category</MuiInputLabel>
            <MuiSelect
              value={selectedCategoryForAll}
              onChange={(e) => setSelectedCategoryForAll(e.target.value)}
              label="Category"
            >
              {categrory?.map((cat) => (
                <MuiMenuItem key={cat.value} value={cat.value}>
                  {cat.name}
                </MuiMenuItem>
              ))}
            </MuiSelect>
          </MuiFormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setApplyCategoryDialogOpen(false)}>Cancel</Button>
          <Button onClick={handleApplyCategoryToAll} variant="contained">Apply</Button>
        </DialogActions>
      </Dialog>

      {/* Apply Visibility Dialog */}
      <Dialog open={applyVisibilityDialogOpen} onClose={() => setApplyVisibilityDialogOpen(false)}>
        <DialogTitle>Apply Visibility to All Videos</DialogTitle>
        <DialogContent>
          <MuiFormControl fullWidth sx={{ mt: 2 }}>
            <MuiInputLabel>Visibility</MuiInputLabel>
            <MuiSelect
              value={selectedVisibilityForAll}
              onChange={(e) => setSelectedVisibilityForAll(e.target.value)}
              label="Visibility"
            >
              {videoVisibilityOptions.filter((option) => option?.value !== '3').map((option) => (
                <MuiMenuItem key={option.value} value={option.value}>
                  {option.name}
                </MuiMenuItem>
              ))}
            </MuiSelect>
          </MuiFormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setApplyVisibilityDialogOpen(false)}>Cancel</Button>
          <Button onClick={handleApplyVisibilityToAll} variant="contained">Apply</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
